/**********************************************************************************
* GENERATED FILE - This file is automatically managed by the MJ CodeGen tool, 
* 
* DO NOT MODIFY THIS FILE - any changes you make will be wiped out the next time the file is
* generated
* 
**********************************************************************************/
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// MemberJunction Imports
import { BaseFormsModule } from '@memberjunction/ng-base-forms';
import { EntityViewerModule } from '@memberjunction/ng-entity-viewer';
import { LinkDirectivesModule } from '@memberjunction/ng-link-directives';

// Import Generated Components
import { SkipConversationDetail__SkipFormComponent } from "./Entities/SkipConversationDetail__Skip/skipconversationdetail__skip.form.component";
import { SkipConversation__SkipFormComponent } from "./Entities/SkipConversation__Skip/skipconversation__skip.form.component";
import { SkipLearningCycleNoteFormComponent } from "./Entities/SkipLearningCycleNote/skiplearningcyclenote.form.component";
import { SkipNoteFormComponent } from "./Entities/SkipNote/skipnote.form.component";
import { SkipUserComponentFeedbackFormComponent } from "./Entities/SkipUserComponentFeedback/skipusercomponentfeedback.form.component";
import { SkipUserComponentFormComponent } from "./Entities/SkipUserComponent/skipusercomponent.form.component";
import { SkipUserComponentLibraryFormComponent } from "./Entities/SkipUserComponentLibrary/skipusercomponentlibrary.form.component";
import { SkipUserComponentUsageFormComponent } from "./Entities/SkipUserComponentUsage/skipusercomponentusage.form.component";
import { SkipUserComponentVersionFormComponent } from "./Entities/SkipUserComponentVersion/skipusercomponentversion.form.component";
   

@NgModule({
declarations: [
    SkipUserComponentLibraryFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_4 { }
    


@NgModule({
declarations: [
    SkipNoteFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_7 { }
    


@NgModule({
declarations: [
    SkipUserComponentUsageFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_8 { }
    


@NgModule({
declarations: [
    SkipUserComponentVersionFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_9 { }
    


@NgModule({
declarations: [
    SkipConversationDetail__SkipFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_10 { }
    


@NgModule({
declarations: [
    SkipConversation__SkipFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_17 { }
    


@NgModule({
declarations: [
    SkipUserComponentFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_21 { }
    


@NgModule({
declarations: [
    SkipUserComponentFeedbackFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_24 { }
    


@NgModule({
declarations: [
    SkipLearningCycleNoteFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_31 { }
    


@NgModule({
declarations: [
],
imports: [
    GeneratedForms_SubModule_4,
    GeneratedForms_SubModule_7,
    GeneratedForms_SubModule_8,
    GeneratedForms_SubModule_9,
    GeneratedForms_SubModule_10,
    GeneratedForms_SubModule_17,
    GeneratedForms_SubModule_21,
    GeneratedForms_SubModule_24,
    GeneratedForms_SubModule_31
]
})
export class GeneratedFormsModule { }
    
// Note: LoadXXXGeneratedForms() functions have been removed. Tree-shaking prevention
// is now handled by the pre-built class registration manifest system.
// See packages/CodeGenLib/CLASS_MANIFEST_GUIDE.md for details.
    